import React from 'react';

const Faq = () => {
  const faqs = [
    {
      id: 1,
      question: "Why should you use love oil?",
      answer:
        "Love oil adds extra hydration to your skin, leaving it soft, silky, and ready for anything. It enhances your skin's moisture and brings fun and intimacy to your routine.",
    },
    {
      id: 2,
      question: "What are the key ingredients?",
      answer:
        "Diddy Love Oil is crafted with 100% natural ingredients like jojoba, coconut, and vitamin E for deep moisturizing, gentle feel, and skin-soothing properties.",
    },
    {
      id: 3,
      question: "How do I use love oil?",
      answer:
        "Apply a few drops to the areas you’d like to keep soft and hydrated. Massage gently until it absorbs. Ideal for everyday moisturizing or extra smoothness.",
    },
    {
      id: 4,
      question: "Are pleasure and satisfaction guaranteed?",
      answer:
        "Absolutely! Diddy Love Oil enhances your skincare routine and confidence, backed by our satisfaction guarantee for a risk-free trial.",
    },
  ];

  return (
    <section className="faq">
      <div className="container-xl">
        <div className='faq-box'>
        <h2>FAQ's</h2>
        <div className="accordion" id="accordionExample">
          {faqs.map(({ id, question, answer }) => (
            <div className="accordion-item" key={id}>
              <h2 className="accordion-header" id={`heading${id}`}>
                <button
                  className="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#collapse${id}`}
                  aria-expanded={id === 1}
                  aria-controls={`collapse${id}`}
                >
                  {question}
                </button>
              </h2>
              <div
                id={`collapse${id}`}
                className={`accordion-collapse collapse ${id === 1 ? 'show' : ''}`}
                aria-labelledby={`heading${id}`}
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body">{answer}</div>
              </div>
            </div>
          ))}
        </div>
        </div>
      </div>
    </section>
  );
};

export default Faq;
